import { MoveUpRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { EXTERNAL_IMAGE_TOOLS } from '../../constants/data';
import { cn } from 'lib/utils';

export default function ExternalTools() {
  const navigate = useNavigate();
  
  const handleNavigation = (link: string) => {
    navigate(link);
  };

  return (
    <div className="py-4 border-t text-text-primary mt-4 flex flex-col gap-2">
      <p className="uppercase text-sm">Image Editor Tools</p>
      <p className="uppercase text-xs">
        Note: This will redirect you to another tool.
      </p>

      {/* Desktop List */}
      <ul className="hidden lg:flex flex-col gap-2 mt-4">
        {EXTERNAL_IMAGE_TOOLS.map((tool) => (
          <li
            key={tool.id}
            onClick={() => handleNavigation(tool.link)}
            className="flex items-center gap-2 rounded-md border p-2 cursor-pointer"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleNavigation(tool.link);
              }
            }}
          >
            <img
              src={tool.imagePath}
              alt={`${tool.text} icon`}
              className="w-8 h-8 object-cover rounded-md"
            />
            <p className="flex-1 text-sm font-medium">{tool.text}</p>
            <MoveUpRight size={16} />
          </li>
        ))}
      </ul>

      {/* Mobile List */}
      <div className="lg:hidden mt-2">
        <div className="grid grid-cols-3 border rounded-md">
          {EXTERNAL_IMAGE_TOOLS.map((tool, index) => (
            <div
              key={tool.id}
              onClick={() => handleNavigation(tool.link)}
              className={cn(
                "flex items-center justify-between p-3 cursor-pointer hover:bg-gray-50 transition-colors",
                index % 3 !== 2 && "border-r",
                index < EXTERNAL_IMAGE_TOOLS.length - 3 && "border-b"
              )}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleNavigation(tool.link);
                }
              }}
            >
              <p className="text-sm font-medium pr-2">{tool.text}</p>
              <MoveUpRight size={16} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 